import type { ProductRewardSearchResult } from '@brandclub/common-ui';
import _orderBy from 'lodash/orderBy';
import { lazy } from 'react';

import { getCatalogV1PriorityEligibleProduct } from './CatalogV1InpageAddToBagContent';

export const StoreLocator = lazy(() => import('../StoreLocator/StoreLocator'));

export const getPriorityEligibleProduct = getCatalogV1PriorityEligibleProduct;

export const getProductsToListForBuyBox = (
  product?: ProductRewardSearchResult,
  checkoutRetailerIds?: number[],
): ProductRewardSearchResult[] => {
  if (!product) {
    return [];
  }

  const checkoutRetailerIdSet = checkoutRetailerIds?.length ? new Set(checkoutRetailerIds) : undefined;
  const productsToList: ProductRewardSearchResult[] = [{ ...product } as ProductRewardSearchResult];
  product.matchedProducts?.forEach((matchedProduct: any) => {
    productsToList.push({ ...matchedProduct });
  });

  const filteredProducts = checkoutRetailerIdSet
    ? productsToList.filter((p) => checkoutRetailerIdSet.has(p.retailerId))
    : productsToList;

  return _orderBy(filteredProducts, (p) => (p.retailPrice || 0) - (p.totalRewardAmount || 0), ['asc']);
};
